// Se reemplaza por LmCommonProps.js
// Se depreca al migrar todos los componentes de formbuilder a este mixin

export default {
  computed: {
    idComputed () {
      return this.id || this.label || ''
    },
    isOnModeLabelOnLeft () {
      return this.mode === 'labelOnLeft'
    },
    titleComputed () {
      return this.labelTitle || this.label || ''
    },
    required () {
      return this.v.required !== undefined
    },
    minLengthCharactersRequired () {
      return this.v.$params.minLength ? this.v.$params.minLength.min : null
    },
    maxLengthCharactersAllowed () {
      return this.v.$params.maxLength ? this.v.$params.maxLength.max : null
    },
    exactLengthRequired () {
      return this.v.$params.exactLength ? this.v.$params.exactLength.exact : null
    },
    wasMaxLengthReached () {
      return this.maxLength === this.value?.length
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    labelTitle: {
      type: String,
      default: ''
    },
    /**
    * Setea la posición del label. Las opciones disponibles son: "labelOnTop", "labelOnLeft"
    */
    mode: {
      type: String,
      default: 'labelOnTop'
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    /**
    * Setea el atributo id del input el cual permite hacer foco sobre el input cuando el usuario hace click sobre el label
    */
    id: {
      type: String,
      default: ''
    },
    /**
    * Al ser seteado agrega un label al input y automática agrega in id al mismo para poder vincular el click sobre el label con el foco en el input.
    */
    label: {
      type: String,
      default: ''
    },
    v: {
      type: Object,
      default: () => ({})
    },
    /**
    * Disabled input
    */
    disabled: {
      type: Boolean,
      default: false
    },
    validateOnfocusOut: {
      type: Boolean,
      default: true
    },
    value: null,
    labelOfFieldUsedForsameAsValidation: {
      type: String,
      default: ''
    }
  },
  methods: {
    validateOnfocusOutMethod () {
      if (this.v.$touch && this.validateOnfocusOut) {
        this.v.$touch()
      }
    }
  }
}
